import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { RouteGuardPermissions } from "@/components/permissions/route-guard-multiple";
import StockTransfersTable from "@/components/stock-transfers/stock-transfers-table";

const searchSchema = z.object({
  page: z.number().optional().default(1),
  search: z.string().optional(),
  status: z.string().optional(),
});

export const Route = createFileRoute("/_authenticated/stock-transfers/")({
  validateSearch: searchSchema,
  component: StockTransfersPage,
});

function StockTransfersPage() {
  const searchParams = Route.useSearch();
  return (
    <RouteGuardPermissions
      permissions={[{ module: "stock_transfers", actions: ["read"] }]}
    >
      <div className="space-y-4">
        <StockTransfersTable
          currentPage={searchParams.page}
          basePath="/stock-transfers"
          searchParams={searchParams}
        />
      </div>
    </RouteGuardPermissions>
  );
}
